import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import {
  IconEraser,
  IconFileSpreadsheet,
  IconFilter,
} from "@tabler/icons-react";
import CustomTable from "../../../components/common/table/CustomTable";
import SimpleTable from "../../../components/common/table/SimpleTable";
import { filterDatesOptions } from "../../../helpers/constants";
import {
  useDonwloadXlxsBlsImportMutation,
  useDownloadBlImportActaMutation,
  useDownloadBlImportMutation,
} from "../../../services/bl-import/BLImportService";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setPageTableBlImport,
  setSizeTableBlImport,
} from "../slices/blImportSlice";
import { BLImport } from "../../../interfaces/bl-import/blImport.interface";
import AutocompleteSearchContainer from "./AutocompleteSearchContainer";
import { useState } from "react";
import { useDownloadCartaMutation } from "../../../services/bl-export/BLExportService";
import { getHeadersBLImportTable } from "../constants/headers.constants";
import useUploadDocument from "../hooks/useUploadDocument";
import ModalUploadDocument from "./ModalUploadDocument";
import { filterOptions } from "../constants/filters.constans";
import useEcas from "../hooks/useEcas";
import DialogUploadEcas from "./DialogUploadExas";
import useBLImport from "../hooks/useBLImport";
import { generateRowsBlImp } from "../helpers/rowsHelper";

export const BlImportsTable = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const { page, size } = useAppSelector((state) => state.blImport);
  const [isDownloadingXlsx, setIsDownloadingXlsx] = useState(false);

  const dispatch = useAppDispatch();

  const {
    idBlUploadDocument,
    openModalUploadDocument,
    closeModalUploadDocument,
  } = useUploadDocument();

  const { idBlEcas, openDialogUploadEcas, closeDialogUploadEcas } = useEcas();

  const {
    filterDays,
    showDonloaded,
    onChangeDownloaded,
    onChangeFilterDays,
    clearFilters,
    dataBls,
    isLoading,
    isFetching,
    isError,
    getBlsImp,
    getFieldProps, //Formik Handlers
    errors, //Formik Handlers
    touched, //Formik Handlers
    handleSubmit, //Formik Handlers
    values, //Formik Handlers
    setFieldValue, //Formik Handlers
    handleDownloadEcas,
  } = useBLImport();

  const [donwloadBlFile] = useDownloadBlImportMutation();
  const [donwloadBlActaFile] = useDownloadBlImportActaMutation();

  // Downloaw Excel
  const [downloadXlsx] = useDonwloadXlxsBlsImportMutation();

  const [_donwloadCarta] = useDownloadCartaMutation();

  const handleDonwloadXlsx = async () => {
    setIsDownloadingXlsx(true);

    const res = await downloadXlsx({
      page,
      size,
      type_filter: values.type,
      value_filter: values.value,
      filter_days: values.filter_days,
      id_usuario: userInfo?.perfil === "1" ? undefined : userInfo?.id!,
      descargados: showDonloaded ? showDonloaded : undefined,
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "bls-import.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        getBlsImp();
      } catch (error) {
        alert(String(error));
      }
    } else {
      alert(String("No se pudo descargar el archivo. Intente luego"));
    }
    setIsDownloadingXlsx(false);
  };

  // Download Carta
  const downloadCarta = async (bl: BLImport) => {
    const res = await _donwloadCarta({
      fileName: bl.carta_gastos || "Null",
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = bl.carta_gastos!;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        getBlsImp();
      } catch (error) {
        alert(String("No se pudo descargar el archivo. Intente luego"));
      }
    } else {
      alert(String("No se pudo descargar el archivo. Intente luego"));
    }
  };

  // actions
  const handleDownload = async (bl: BLImport) => {
    const res = await donwloadBlFile({
      fileName: bl.nombre_archivo!,
      id_bl: Number(bl.id),
      id_usuario: Number(userInfo?.id!),
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = bl.nombre_archivo!;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        getBlsImp();
      } catch (error) {
        alert(String(error));
      }
    } else {
      alert("No se puede descargar el archivo en este momento.");
    }
  };

  const handleDownloadActa = async (bl: BLImport) => {
    const res = await donwloadBlActaFile({
      id_bl: Number(bl.id),
      id_usuario: Number(bl.id_usuario_descarga!),
    });

    if ("data" in res && res.data instanceof Blob) {
      try {
        const url = window.URL.createObjectURL(res.data);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `acta_${bl.hbl}`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        getBlsImp();
      } catch (error) {
        alert(String(error));
      }
    } else {
      alert("No se puede descargar el archivo en este momento.");
    }
  };

  const isAdminUser = userInfo?.perfil === "1" ? true : false;
  const tableOffset = page * size;

  const headers = getHeadersBLImportTable(isAdminUser);

  const rows = generateRowsBlImp(
    isAdminUser,
    handleDownload,
    handleDownloadActa,
    openModalUploadDocument,
    openDialogUploadEcas,
    downloadCarta,
    handleDownloadEcas,
    tableOffset,
    getBlsImp,
    dataBls
  );

  return (
    <>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="filtro-label">Creación BLs</InputLabel>
          <Select
            labelId="filtro-label"
            label="Creación BLs"
            onChange={(e) => {
              onChangeFilterDays(String(e.target.value));
            }}
            value={filterDays}
          >
            {filterDatesOptions.map((opt, index) => (
              <MenuItem key={index} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        <FormControl
          fullWidth
          variant="outlined"
          error={Boolean(errors.type && touched.type)}
        >
          <InputLabel id="filtro-label">Tipo Filtro</InputLabel>
          <Select
            labelId="filtro-label"
            label="Tipo Filtro"
            {...getFieldProps("type")}
            error={Boolean(errors.type && touched.type)}
          >
            {filterOptions.map((opt, index) => (
              <MenuItem key={index} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
          {Boolean(errors.type && touched.type) && (
            <FormHelperText>{errors.type}</FormHelperText>
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} md={4} lg={4}>
        {values.type === "contenedores" ? (
          <FormControl fullWidth variant="outlined">
            <AutocompleteSearchContainer
              error={Boolean(errors.value && touched.value)}
              helperText={
                Boolean(errors.value && touched.value) && errors.value
              }
              onChange={(val) => setFieldValue("value", val)}
            />
          </FormControl>
        ) : (
          <TextField
            fullWidth
            variant="outlined"
            label="Valor"
            {...getFieldProps("value")}
            error={Boolean(errors.value && touched.value)}
            helperText={Boolean(errors.value && touched.value) && errors.value}
          />
        )}
      </Grid>
      {userInfo?.perfil === "1" && (
        <Grid item xs={12} sm={12} md={3}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                checked={showDonloaded}
                onChange={(_, val) => onChangeDownloaded(val)}
                name="checkedA"
              />
            }
            label="Descargados"
          />
        </Grid>
      )}
      <Grid item container xs={12} justifyContent="flex-end" spacing={1}>
        <Grid item>
          <Button
            onClick={() => handleSubmit()}
            variant="contained"
            color="primary"
            startIcon={<IconFilter />}
          >
            Filtrar
          </Button>
        </Grid>

        <Grid item>
          <Button
            onClick={clearFilters}
            variant="contained"
            color="secondary"
            startIcon={<IconEraser />}
          >
            Limpiar Filtros
          </Button>
        </Grid>
        {userInfo?.perfil === "1" && (
          <Grid item>
            <Button
              onClick={handleDonwloadXlsx}
              variant="outlined"
              startIcon={<IconFileSpreadsheet />}
              style={{ color: "green", borderColor: "green" }}
              disabled={isDownloadingXlsx}
              endIcon={isDownloadingXlsx && <CircularProgress size={20} />}
            >
              Exportar Excel
            </Button>
          </Grid>
        )}
      </Grid>

      <Grid item xs={12} md={12} lg={12}>
        <CustomTable
          dense={true}
          isCollapsible
          isLoading={isLoading || isFetching}
          isError={isError}
          rows={rows}
          headers={headers}
          totalRecords={Number(dataBls?.total) || 0}
          page={page}
          rowsPerPage={size}
          onChangePage={(page) => {
            dispatch(setPageTableBlImport(page));
          }}
          onChangeRowsPerPage={(rowsPerPage) => {
            dispatch(setSizeTableBlImport(rowsPerPage));
          }}
          CollapseContent={
            dataBls?.data?.map((dt) => (
              <SimpleTable
                headers={[
                  "mrn",
                  "contenedores",
                  "destino",
                  "mbl",
                  "observaciones",
                ]}
                rows={[
                  {
                    mrn: dt.mrn,
                    contenedores: dt.contenedores,
                    destino: dt.destino,
                    mbl: dt.mbl,
                    observaciones: dt.observaciones,
                  },
                ]}
              />
            )) || []
          }
        />
      </Grid>
      <ModalUploadDocument
        idBl={idBlUploadDocument}
        onClose={closeModalUploadDocument}
        callback={getBlsImp}
      />
      <DialogUploadEcas
        idBl={idBlEcas}
        onClose={closeDialogUploadEcas}
        callback={getBlsImp}
      />
    </>
  );
};
